__turbopack_context__.v({
  "dot-jump": "Loader-module-scss-module__WV3w5a__dot-jump",
  "loader": "Loader-module-scss-module__WV3w5a__loader",
  "loader_main": "Loader-module-scss-module__WV3w5a__loader_main",
  "loader_sec": "Loader-module-scss-module__WV3w5a__loader_sec",
  "loading-text": "Loader-module-scss-module__WV3w5a__loading-text",
});
